import { CSSObject } from 'styled-components';

/**
 * Убирает название родительского блока из строки со стилями
 * ключ 'Header1.Button.text' => 'Button.text'
 * TODO вынести в отдельный хелпер, потребуется для других компонентов
 */
 export const getPartialStyles = (styles: Record<string, unknown>, name: string): CSSObject => {
  const partialStyles = {};

  for (const key in styles) {
      const position = key.search(name);
      if (position !== -1) {
          const partialKey = key.slice(position);
          partialStyles[partialKey] = styles[key];
      }
  }
  return partialStyles;
};
